import { jsxs as s, jsx as n } from "@emotion/react/jsx-runtime";
import { useState as E, useRef as M, useMemo as H } from "react";
import { useClickOutside as K } from "../../hooks/useClickOutside.js";
import { FiltersContainer as N, DropdownContainer as W, ContentContainer as _, StyledText as G, StyledCloseIcon as J, StatusNumber as Q, MenuListWrapper as V } from "./Filters.styled.js";
import { Icon as P } from "../Icon/index.js";
import { Stack as D } from "../Stack/index.js";
import { Text as I } from "../Text/index.js";
import { MenuList as Y } from "../MenuList/MenuList.js";
import { FontAwesomeIconsPartooUsed as h, IconPrefix as j } from "../../types/components/icon.js";
const v = /* @__PURE__ */ n(P, { icon: ["fa-asterisk"], color: "danger", iconSize: "8px" }), so = ({
  dataTrackId: y,
  placeholder: l,
  position: C = "bottom",
  multiple: t = !1,
  menuListArray: k = [],
  selectedItems: e,
  selectableCardChildren: F,
  maxHeight: R,
  disabled: c,
  readOnly: b = !1,
  onChange: g,
  icon: X,
  disableReset: p = !1,
  required: w = !1
}) => {
  const [u, x] = E(!1), O = M(null), T = M(null), U = () => {
    c || x(!0);
  }, $ = () => {
    const o = e && Object.keys(e)[0], f = (d) => {
      const i = k.flatMap((a) => a.options).find((a) => a.name === d);
      return i ? i.label : l;
    };
    return !t && r === 1 && o ? f(o) : /* @__PURE__ */ s(D, { gap: "4px", direction: "row", children: [
      l,
      !!w && v
    ] });
  }, z = (o, f) => {
    if (f.currentTarget instanceof HTMLInputElement) {
      const {
        name: d,
        checked: i,
        type: a
      } = f.currentTarget;
      let m;
      a === "radio" ? (m = {
        [d]: i
      }, S()) : m = {
        ...e,
        [d]: i
      }, g(m);
    }
  }, r = H(() => e ? Object.entries(e).filter(([, o]) => o).length : 0, [e]), S = () => {
    x(!1);
  }, A = (o) => {
    p || (o.stopPropagation(), g({}));
  };
  K({
    refs: [O, T],
    onClickOutside: S
  });
  const L = !t && r > 0, B = r === 0 || p && !t;
  return /* @__PURE__ */ s(N, { disabled: c, "data-readonly": b, children: [
    /* @__PURE__ */ s(W, { ref: T, onClick: c ? void 0 : U, isOpen: u, disabled: c, "data-readonly": b, children: [
      /* @__PURE__ */ s(_, { displayLabel: L, children: [
        L && /* @__PURE__ */ s(D, { gap: "4px", direction: "row", children: [
          /* @__PURE__ */ n(I, { variant: "bodyXSSemibold", as: "span", color: "secondary", children: l }),
          !!w && v
        ] }),
        /* @__PURE__ */ n(G, { variant: r > 0 ? "bodyMRegular" : "bodyMSemibold", as: "div", color: r > 0 ? "default" : "secondary", oneLine: !0, noTooltip: !0, children: $() })
      ] }),
      !p && r > 0 && /* @__PURE__ */ n(J, { onClick: A, dataTrackId: `reset-filters-${y}`, color: "secondary", icon: [h.faCircleXmark, j.SOLID] }),
      B && /* @__PURE__ */ n(P, { dataTrackId: `show-filters-${y}`, color: "secondary", icon: X ?? [u ? h.faCaretUp : h.faCaretDown, j.SOLID] }),
      t && r > 0 && /* @__PURE__ */ n(Q, { children: /* @__PURE__ */ n(I, { variant: "bodyXSSemibold", color: "white", children: r }) })
    ] }),
    u && /* @__PURE__ */ n(V, { ref: O, position: C, children: /* @__PURE__ */ n(Y, { position: C, maxHeight: R, sections: k, itemType: t ? "checkbox" : "radio", isChecked: ({
      name: o
    }) => e?.[o] ?? !1, onChange: z, selectableCardChildren: F }) })
  ] });
};
export {
  so as Filters
};
